import React from 'react';
import Text, {TEXT_COLOR, TEXT_SIZE, TEXT_WEIGHT} from "@components/Text";
import {Cell} from "@shared/Resources/shared/components/ResourcesList/styles";

export const renderRowData = (displayData, item, isSelected) => {
    return displayData.map(({getDisplay, textOptions}, index) => {
        const {size, color, weight, withEllipsis, align, cellStyle} = textOptions;
        const currentColor = isSelected
            ? TEXT_COLOR.ACTIVE
            : color || TEXT_COLOR.DISABLED;

        const alignStyle = (() => {
            switch (align) {
                case 'center':
                    return { justifyContent: 'center', textAlign: 'center' };
                case 'right':
                    return { justifyContent: 'flex-end', textAlign: 'right' };
                case 'left':
                default:
                    return { justifyContent: 'flex-start', textAlign: 'left' };
            }
        })();

        return (
            <Cell
                key={`${item.id}-${index}`}
                withEllipsis={withEllipsis}
                color={currentColor}
                style={{ ...alignStyle, ...(cellStyle || {}) }}
            >
                <Text
                    size={size || TEXT_SIZE.T5}
                    textColor={currentColor}
                    weight={weight || TEXT_WEIGHT.NORMAL}
                    withEllipsis={withEllipsis}
                >
                    {getDisplay(item, isSelected)}
                </Text>
            </Cell>
        );
    })
};